export default {"src":"/_next/static/image/components/ui/Icon/icons/check.9071ab76ccf35f30397578d8c562eafd.svg","height":24,"width":24};